import { Injectable } from '@angular/core';
import { Adapter } from '@app/core/adapter';
import { CountryAdapter } from '@app/core/services/country/country.adapter';
import { AssetGroup } from '@app/shared/models/asset-group.model';
import { ASSET_GROUP_ICONS } from '@app/shared/constants/asset-groups';
import { ShiftAdapter } from '@core/services/adapters/shift.adapter';
import { Shift } from '@app/shared/models/shift.model';

@Injectable()
export class AssetGroupAdapter implements Adapter<AssetGroup> {
    constructor(private countryAdapter: CountryAdapter, private shiftAdapter: ShiftAdapter) {}
    adapt(data: any): AssetGroup {
        const shiftIds: number[] = [];
        const shiftsList: Shift[] = [];

        if (data.shifts && data.shifts.length) {
            if (Number.isNaN(Number(data.shifts[0]))) {
                shiftsList.push(...data.shifts.map((shift) => this.shiftAdapter.adapt(shift)));
                shiftIds.push(...shiftsList.map((shift) => shift.id));
            } else {
                shiftIds.push(...data.shifts);
            }
        }

        return {
            id: data.id || 0,
            name: data.groupValue || '',
            type: data.groupType || '',
            icon: this.getIcon(data.groupType),
            parentId: data.parentGroupId || 0,
            contact: {
                inherited: data.contactIsInherited || false,
                name: data.contactName || '',
                phone: data.contactPhone || '',
            },
            location: {
                inherited: data.locationIsInherited || false,
                address: data.address || '',
                city: data.city || '',
                state: data.state || '',
                country: data.country || this.countryAdapter.adapt({}),
                zip: data.zip || '',
            },
            shifts: {
                inherited: data.shiftListIsInherited || false,
                ids: shiftIds,
                list: shiftsList,
            },
            timezone: {
                inherited: data.timezoneIsInherited || false,
                code: data.timezoneCode || data.timezone || '',
            },
            href: data.href || '',
            children: data.children || [],
        } as AssetGroup;
    }

    private getIcon(type: string): string {
        let icon = '';

        if (Object.keys(ASSET_GROUP_ICONS).includes(type)) {
            icon = ASSET_GROUP_ICONS[type];
        }

        return icon;
    }
}
